import { RouteRecordRaw } from "vue-router";
import HomePage from "@/views/HomePage.vue";
import ExampleListPage from "@/views/Example/ExampleListPage.vue";
import ExamplePage from "@/views/Example/ExamplePage.vue";
import ProductPage from "@/views/ProductPage.vue";
import ContactUsPage from "@/views/ContactUsPage.vue";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "首页",
    component: HomePage,
  },
  {
    path: "/product",
    name: "产品特色",
    component: ProductPage,
  },
  {
    path: "/example",
    name: "案例欣赏",
    component: ExamplePage,
    children: [
      {
        path: "/example/list",
        name: "所有案例",
        component: ExampleListPage,
      },
    ],
  },
  {
    path: "/contact",
    name: "联系我们",
    component: ContactUsPage,
  },
];
